module.exports = __webpack_public_path__ + "img/hash-01.2f8e3f78.svg";